import { pdpPageCategories } from '../services/analytics-service/categories'

export function getCategory(isComboListing: boolean): pdpPageCategories {
    return isComboListing ? pdpPageCategories.PDP_PAGE_COMBO : pdpPageCategories.PDP_PAGE
}
